const COOKIE_NAME = 'compass_bigscreen'
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365

export function useBigScreenMode() {
  const cookie = useCookie<boolean>(COOKIE_NAME, {
    default: () => false,
    maxAge: ONE_YEAR_SECONDS,
    sameSite: 'lax',
    path: '/',
  })

  function set(value: boolean) {
    cookie.value = value
  }

  function toggle() {
    cookie.value = !cookie.value
  }

  return { isBigScreen: cookie, set, toggle }
}
